import type { Tokens } from '../../../theming/types'
import type { InputDescriptionProps } from '..'

export default (config: {
  props: Pick<InputDescriptionProps, 'kind'>
  tokens: Tokens
}) => {
  const { tokens, props } = config
  return {
    default: {
      wrap: {
        ...tokens.fontDetailS,
        display: props.kind === 'error' ? 'flex' : undefined,
        margin: 0,
        padding: 0,

        '& > svg': {
          fill: 'currentColor',
          flex: props.kind === 'error' ? '0 0 auto' : undefined,
          marginInlineEnd: '8px',
        },
      },
    },

    helper: {
      wrap: {
        color: tokens.fontColorSubtle,
      },
    },

    error: {
      wrap: {
        color: tokens.fontColorError,
      },
    },

    disabled: {
      cursor: 'not-allowed',
      opacity: tokens.opacityDisabled,
    },
  } as const
}
